var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mt-5",staticStyle:{"background-color":"#1c344b"},attrs:{"small":"","dark":""},on:{"click":_vm.submit}},[_c('icon',{staticClass:"mr-3",attrs:{"icon":"cloud-download-alt"}}),_vm._v("Generate Report")],1)}
var staticRenderFns = []

export { render, staticRenderFns }